import { Navigate } from 'react-router';
import { useAuth } from 'providers/AuthProvider';
import { Spinner } from 'components';

function LandingScreen() {
  const { isAuthenticated, loading } = useAuth();

  if (loading && !isAuthenticated) {
    return <Spinner />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Navigate to="/home" replace />;
}

export default LandingScreen;
